import { Search as SearchIcon } from '@tunasong/icons'
import type { SearchFilter as SearchFilterType } from '@tunasong/schemas'
import { HBox, TagList, disableAutocomplete, CircularProgress, TextField } from '@tunasong/ui-lib'
import type { TextFieldProps } from '@tunasong/ui-lib'
import cn from 'classnames'
import type { ChangeEvent, FC } from 'react'
import styles from './search-input.module.css'

export interface SearchInputProps extends Omit<TextFieldProps, 'onChange'> {
  className?: string
  query: string
  loading: boolean
  placeholder: string
  fullWidth?: boolean
  filter?: SearchFilterType
  inputRef?: (el: HTMLElement | null) => void
  onChange(ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void
}

export const SearchInput: FC<SearchInputProps> = props => {
  const { fullWidth, placeholder, query, loading, filter, onChange, inputRef, className, ...restProps } = props
  const tags = [filter?.tags ?? [], filter?.types?.map(type => `type:${type}`)].filter(Boolean).flat()

  return (
    <TextField
      {...restProps}
      ref={inputRef}
      fullWidth={fullWidth}
      value={query}
      variant="standard"
      InputProps={{
        startAdornment: (
          <div className={styles.searchIconWrapper}>
            <SearchIcon />
          </div>
        ),
        endAdornment: (
          <>
            {loading ? (
              <HBox className={styles.loadingWrapper}>
                <CircularProgress color="inherit" size={20} />
              </HBox>
            ) : null}
            <TagList tags={tags} />
          </>
        ),
      }}
      onChange={onChange}
      placeholder={placeholder}
      inputProps={{ ...disableAutocomplete }}
      className={cn(styles.textField, className)}
    />
  )
}

export default SearchInput
